import React from 'react';
import PropTypes from 'prop-types';
import { Grid } from '@mui/material';
import ServiceButtonWithToast from '../../_common/ServiceButtonWithToast';

export default function SelectedAnyRfvSubForm(props) {
  const {
    onSubmit,
    onSuccess,
    successMsg,
  } = props;

  const handleSave = () => onSubmit({
    conditionType: 'selectedAnyRfv',
  });

  return (
    <Grid item xs={10}>
      <ServiceButtonWithToast
        service={handleSave}
        onSuccess={onSuccess}
        successMsg={successMsg}
        buttonText="Save"
      />
    </Grid>
  );
}

SelectedAnyRfvSubForm.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  onSuccess: PropTypes.func,
  successMsg: PropTypes.string,
};

SelectedAnyRfvSubForm.defaultProps = {
  onSuccess: undefined,
  successMsg: undefined,
};
